export const seoAudit = {
  title: '360 Audit',
  badge: 'Technical SEO',
  form: {
    title: '360 Audit',
    subtitle: 'Analiza tu sitio web en busca de problemas técnicos de SEO: meta tags, links rotos, datos estructurados, imágenes y más.',
    urlLabel: 'URL del sitio web',
    urlPlaceholder: 'https://tuempresa.com',
    advancedConfig: 'Configuración avanzada',
    maxDepth: 'Profundidad máxima',
    maxDepthTooltip: 'Profundidad máxima de crawl desde la URL de inicio (1-10).',
    maxUrls: 'URLs máximas',
    maxUrlsTooltip: 'Número máximo de URLs a crawlear. Dejar vacío para usar el valor por defecto del crawler.',
    maxUrlsPlaceholder: 'Por defecto (sin límite)',
    jsRendering: 'Renderizado JavaScript (Chromium)',
    jsRenderingWarning: 'Activar el renderizado JS usa un navegador Chromium headless para cada página, lo que puede aumentar el tiempo de crawl hasta 5×.',
    submitButton: 'Iniciar auditoría SEO',
    submitting: 'Iniciando auditoría...',
    includePatterns: 'Incluir patrones de URL',
    includePatternsPlaceholder: '/blog/, /productos/',
    includePatternsTooltip: 'Solo crawlear URLs que coincidan con estos patrones. Dejar vacío para crawlear todo el sitio.',
    excludePatterns: 'Excluir patrones de URL',
    excludePatternsPlaceholder: '/admin/, /wp-json/',
    excludePatternsTooltip: 'Omitir URLs que coincidan con estos patrones durante el crawl.',
    includeExtensions: 'Incluir extensiones de archivo',
    includeExtensionsPlaceholder: 'html, php',
    includeExtensionsTooltip: 'Solo crawlear archivos con estas extensiones.',
    excludeExtensions: 'Excluir extensiones de archivo',
    excludeExtensionsPlaceholder: 'pdf, zip, mp4',
    excludeExtensionsTooltip: 'Omitir archivos con estas extensiones durante el crawl.',
    userAgent: 'User agent',
    userAgentPlaceholder:
      'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/131.0.0.0 Safari/537.36',
    userAgentTooltip: 'Header user-agent personalizado enviado con cada request. Útil para sitios que bloquean crawlers por defecto.',
    userAgentPreset: {
      placeholder: 'Elegí un preset…',
      custom: 'Custom (escribilo a mano)',
      chromeLinux: 'Chrome — Desktop (Linux) · recomendado',
      chromeWindows: 'Chrome — Desktop (Windows)',
      chromeMacos: 'Chrome — Desktop (macOS)',
      chromeMobile: 'Chrome — Mobile (Android)',
      safariIphone: 'Safari — Mobile (iPhone)',
      googlebotDesktop: 'Googlebot — Desktop',
      googlebotMobile: 'Googlebot — Smartphone',
    },
    crawlDelay: 'Delay de crawl (segundos)',
    crawlDelayTooltip: 'Delay entre requests en segundos. Aumentar para sitios con rate-limit.',
    concurrency: 'Concurrencia',
    concurrencyTooltip: 'Número de requests concurrentes. Valores más bajos son más amigables con el servidor.',
    allowCookies: 'Permitir cookies',
    allowCookiesTooltip: 'Aceptar y enviar cookies durante el crawl. Necesario para sitios con autenticación o sesiones.',
    respectRobotsTxt: 'Respetar robots.txt',
    respectRobotsTxtTooltip: 'Seguir las directivas de robots.txt. Desactivar para crawlear todas las páginas.',
    timeout: 'Timeout de request (ms)',
    timeoutTooltip: 'Tiempo máximo de espera para cada respuesta de página.',
    retries: 'Reintentos',
    retriesTooltip: 'Número de reintentos para requests fallidos.',
    enableProxy: 'Habilitar proxy',
    enableProxyTooltip: 'Enrutar los requests del crawler a través del servidor proxy configurado.',
    jsWaitTime: 'Tiempo de espera JS (ms)',
    jsWaitTimeTooltip: 'Tiempo de espera después de la carga de la página para que JavaScript renderice el contenido.',
    jsTimeout: 'Timeout de JS (ms)',
    jsTimeoutTooltip: 'Tiempo máximo de espera para que el renderizado JavaScript se complete.',
    discoverSitemaps: 'Descubrir sitemaps',
    discoverSitemapsTooltip: 'Descubrir y usar sitemap.xml automáticamente para encontrar páginas adicionales.',
    targetKeywords: 'Palabras clave objetivo',
    targetKeywordsPlaceholder: 'auditoría seo, seo técnico',
    targetKeywordsTooltip: 'Ingresa palabras clave objetivo para verificar la optimización en tu sitio. La auditoría verificará la ubicación de las palabras clave en títulos, descripciones, headings y URLs.',
    brandName: 'Nombre de marca (opcional)',
    brandNamePlaceholder: 'ej. Acme Corp',
    brandNameTooltip: 'Sobreescribe el nombre de marca auto-detectado para los checks de Wikipedia y Wikidata. Deja vacío para auto-detectar desde el schema de Organización o dominio.',
    sectionFilters: 'Filtros de URL',
    sectionCrawler: 'Configuración del Crawler',
    sectionProxy: 'Proxy',
    sectionJsRendering: 'Renderizado JavaScript',
    howToCheck: 'Cómo verificar:',
    probeButton: 'Analizar sitio',
    probeButtonLoading: 'Analizando...',
  },
  probe: {
    bannerAppliedTitle: 'Configuración recomendada aplicada',
    bannerWarningsTitle: 'Advertencias',
    revert: 'Revertir',
    fieldBadge: 'Auto-detectado',
    spaDetected_angular: 'SPA Angular detectada — renderizado JS activado',
    spaDetected_react: 'SPA React detectada — renderizado JS activado',
    spaDetected_next: 'Next.js (client-side) detectado — renderizado JS activado',
    spaDetected_vue: 'SPA Vue detectada — renderizado JS activado',
    spaDetected_unknown: 'Single-page app detectada — renderizado JS activado',
    sitemapFound: 'Sitemap válido encontrado',
    sitemapMalformed: 'Existe una URL de sitemap pero devuelve HTML en lugar de XML — el servidor probablemente devuelve la homepage para rutas no encontradas',
    sitemapNotFound: 'No se encontró sitemap en las rutas habituales — se desactiva el descubrimiento de sitemaps para evitar pedidos innecesarios',
    robotsBlocksAll: 'El robots.txt bloquea todos los crawlers — el crawl puede devolver pocas páginas',
    robotsCrawlDelay: 'El robots.txt define un crawl delay — la auditoría tardará más de lo habitual',
    botProtection_cloudflare:
      'Se detectó desafío de Cloudflare — activando renderizado JS con user agent realista de navegador para sortearlo',
    botProtection_akamai:
      'Se detectó Akamai Bot Manager — activando renderizado JS con user agent realista. Puede seguir fallando desde IPs de datacenter (puede requerir proxy residencial).',
    botProtection_forbidden:
      'El sitio devolvió 403 Forbidden — activando renderizado JS con user agent realista para parecer un Chrome real',
    botProtection_rate_limit:
      'El sitio devolvió 429 Too Many Requests — activando renderizado JS y considerá bajar la concurrencia',
    botProtectionUserAgent:
      'Configurando user agent realista de Chrome — los sitios con protección anti-bot rechazan los UAs de crawlers por defecto',
    botProtectionRobots:
      'Desactivando robots.txt — los sitios con protección anti-bot suelen bloquear el propio robots.txt, así que no hay nada que respetar',
    unreachable: 'No se pudo alcanzar el sitio — verificá la URL e intentá de nuevo',
    noIssuesFound: 'Sin problemas detectados — la configuración por defecto es adecuada para este sitio',
  },
  progress: {
    pending: 'Preparando...',
    crawling: 'Crawling en progreso...',
    processing: 'Procesando resultados...',
    analyzing: 'Analizando',
    pagesCrawled: 'páginas crawleadas',
    discovered: 'descubiertas',
    urlLimit: 'Límite',
    urlLimitUnlimited: 'Ilimitado',
    substeps: {
      geoResearch: 'Investigando la huella externa de la marca',
      geo: 'Puntuando la presencia en IA',
      competitorCensus: 'Relevando el mercado competitivo',
      presence: 'Analizando la presencia competitiva',
      presenceResearch: 'Investigando a los competidores',
      presenceClassify: 'Clasificando competidores',
      presenceFormat: 'Ordenando los datos de competencia',
      presenceSynthesis: 'Sintetizando la comparativa',
      presenceEnrichment: 'Midiendo competidores confirmados',
      keywordGap: 'Cruzando keywords con la competencia',
      expressBenchmark: 'Comparando contra competidores del mercado',
      aiChecks: 'Revisando el contenido con IA',
      aiDocs: 'Redactando la documentación',
      report: 'Armando el reporte',
    },
    waitMessage: 'El crawl tarda ~5 minutos por cada 1.000 URLs. El análisis y la generación de documentación añaden otros ~5 minutos.',
    steps: {
      discovering: 'Descubriendo páginas',
      discoveringDesc: 'Escaneando sitemaps y buscando páginas para crawlear...',
      crawling: 'Crawleando páginas',
      crawlingDesc: 'Obteniendo y analizando el contenido de las páginas...',
      analyzing: 'Analizando resultados',
      analyzingDesc: 'Ejecutando checks de SEO y detectando problemas...',
      generatingDocs: 'Generando documentación',
      generatingDocsDesc: 'Creando recomendaciones accionables con IA...',
      geoPresence: 'Análisis GEO y Presencia',
      geoPresenceDesc: 'Analizando visibilidad de marca en IA y plataformas sociales...',
      confirmCompetitors: 'Revisar competidores',
      confirmCompetitorsDesc: 'Confirma los competidores detectados por IA antes de generar el reporte.',
      refineCompetitors: 'Midiendo competidores confirmados',
      refineCompetitorsDesc: 'Métricas de dominio de los competidores que confirmaste.',
      keywordGap: 'Analizando brechas de keywords',
      keywordGapDesc: 'Identificando keywords en las que tus competidores rankean y tú no...',
      generatingReport: 'Generando reporte 360°',
      generatingReportDesc: 'Sintetizando todos los datos en tu reporte final...',
    },
    awaitingConfirmation: 'Se requiere tu revisión',
    awaitingConfirmationDesc: 'Revisa y confirma los competidores antes de generar el reporte.',
  },
  report: {
    headerSubtitle: 'Reporte 360 Audit',
    radar: {
      score: 'Puntuación',
      categories: {
        indexing: 'Indexación',
        onPage: 'On-Page',
        schema: 'Datos Estructurados',
        links: 'Enlaces',
        images: 'Imágenes',
        contentStructure: 'Contenido',
        eeat: 'E-E-A-T',
        keywords: 'Palabras Clave',
        external: 'Externo',
      },
    },
    pagesAnalyzed: '{{count}} páginas analizadas',
    print: 'Imprimir',
    regenerateDocs: 'Regenerar docs',
    scoreOverview: 'Resumen de Puntuación',
    detailedResults: 'Resultados Detallados',
    backToAudits: 'Volver a auditorías',
    crawlBlocked: {
      title: 'Crawl parcialmente bloqueado',
      detail:
        '{{blocked}} de {{total}} páginas ({{pct}}%) devolvieron HTTP 429 — típicamente un challenge de protección anti-bots (ej. Cloudflare). Los checks de contenido se evaluaron sólo sobre las páginas que cargaron correctamente, por lo que algunos resultados pueden estar incompletos. Reintentá con un proxy habilitado o menor velocidad de crawl para cobertura completa.',
    },
    newAudit: 'Nueva Auditoría',
  },
  summary: {
    score: 'Puntuación',
    passed: 'Aprobados',
    failed: 'Fallidos',
    warnings: 'Advertencias',
    pages: 'Páginas',
  },
  sections: {
    indexing: {
      title: 'Indexación',
      description: 'Verifica los status codes, robots meta tags, URLs canónicas, redirects y directivas de indexación de tu sitio.',
    },
    onPage: {
      title: 'SEO On-Page',
      description: 'Análisis de meta títulos, descripciones, etiquetas H1, atributos lang y duplicación de contenido.',
    },
    schema: {
      title: 'Datos Estructurados',
      description: 'Revisión de Schema.org, JSON-LD, Article, FAQ y datos estructurados para mejorar la visibilidad en buscadores.',
    },
    links: {
      title: 'Enlaces',
      description: 'Análisis de enlaces internos, externos, páginas huérfanas, loops de redirect y profundidad de enlaces.',
    },
    images: {
      title: 'Imágenes',
      description: 'Revisión de cobertura de texto alternativo, tamaño de archivos, peso de imágenes por página y nombres descriptivos.',
    },
    contentStructure: {
      title: 'Estructura del Contenido',
      description: 'Jerarquía de headings, contenido thin, peso de página, tiempos de carga y análisis de estructura.',
    },
    eeat: {
      title: 'E-E-A-T',
      description: 'Señales de Experiencia, Expertise, Autoridad y Confianza: página de about, información de contacto, atribución de autores, política de privacidad y prueba social.',
    },
    keywordOptimization: {
      title: 'Optimización de Palabras Clave',
      description: 'Análisis de la ubicación de palabras clave objetivo en URLs, títulos, meta descripciones, H1 y H2 headings en tu sitio.',
    },
    externalPresence: {
      title: 'Presencia Externa',
      description: 'Verifica la visibilidad de tu sitio en motores de búsqueda, bases de conocimiento y sistemas de IA.',
    },
    manualChecklist: {
      title: 'Checklist de Revisión Manual',
      description: 'Estos ítems requieren revisión manual y no afectan la puntuación automática de la auditoría. Expande cada ítem para ver la guía.',
      completed: 'completados',
    },
  },
  checksTable: {
    check: 'Check',
    status: 'Estado',
    count: 'Cant.',
    statusLabels: {
      pass: 'Aprobado',
      fail: 'Fallo',
      warning: 'Advertencia',
      na: 'N/A',
    },
  },
  documentation: {
    problem: 'Problema',
    technicalSolution: 'Solución Técnica',
    clientCopy: 'Copy para Cliente',
    priority: 'Prioridad',
    copyToClipboard: 'Copiar',
    copied: 'Copiado!',
    priorityLabels: {
      critical: 'Crítica',
      high: 'Alta',
      medium: 'Media',
      low: 'Baja',
    },
  },
  history: {
    title: 'Historial de Auditorías',
    toggleUpload: 'Alternar carga de CSV',
    loading: 'Cargando historial...',
    empty: 'No hay auditorías previas',
    searchLabel: 'Buscar auditorías por URL',
    searchPlaceholder: 'Buscar por URL...',
    statusLabels: {
      completed: 'Completado',
      crawling: 'Crawling',
      processing: 'Procesando',
      pending: 'Pendiente',
      failed: 'Fallido',
      analyzing_geo: 'Análisis GEO',
      analyzing_presence: 'Análisis de Presencia',
      awaiting_confirmation: 'Esperando Revisión',
      analyzing_presence_targeted: 'Re-analizando Competidores',
      analyzing_keyword_gaps: 'Brechas de Keywords',
      analyzing_benchmark: 'Benchmark Express',
      generating_report: 'Generando Reporte',
    },
    pagination: {
      prev: 'Página anterior',
      next: 'Página siguiente',
      pageOf: 'Página {{page}} de {{total}}',
    },
    upload: {
      invalidFileType: 'Por favor selecciona un archivo CSV',
      uploadFailed: 'Error al subir el archivo',
      title: 'Subir exportación CSV de LibreCrawl',
      uploading: 'Subiendo…',
      retry: 'Reintentar',
      uploadCsv: 'Subir CSV',
    },
  },
  error: {
    title: 'Error en la auditoría',
    defaultMessage: 'Ocurrió un error inesperado',
    reportFailed:
      'No se pudo generar el reporte. Todo lo que midió la auditoría está guardado, así que reintentar solo vuelve a escribir el reporte.',
    auditFailed: 'No se pudo completar la auditoría. Iniciá una auditoría nueva para volver a intentarlo.',
    retryReport: 'Reintentar el reporte',
    retryingReport: 'Reintentando el reporte…',
    backToAudits: 'Volver a auditorías',
    resumeFailed: 'No se pudo reiniciar el reporte. Intentá de nuevo en un momento.',
    technicalDetail: 'Detalle técnico: {{message}}',
  },
  competitors: {
    title: 'Confirmar competidores',
    subtitle: 'La IA identificó estos competidores del análisis de presencia de tu marca. Revisa y edita antes de generar el reporte.',
    namePlaceholder: 'Nombre de la empresa',
    urlPlaceholder: 'https://competidor.com',
    reasonLabel: 'Razón de la IA',
    typeLabel: 'Tipo',
    typeDirect: 'Directo',
    typeIndirect: 'Indirecto',
    confirmButton: 'Confirmar y generar reporte',
    confirming: 'Generando reporte...',
    addButton: 'Agregar competidor',
    removeLabel: 'Eliminar competidor',
    sourceBoth: 'Datos de búsqueda + investigación',
    sourceAgentic: 'Investigación de mercado',
    sourceDataForSeo: 'Datos de búsqueda',
    tierLeader: 'Líder de categoría',
    tierPeer: 'Tamaño comparable',
    tierNational: 'Operador nacional',
    evidenceLabel: 'Fuente',
    evidenceOwnSite: 'Fuente: su propio sitio',
    consolidatedWith: 'Mismo operador que',
    confirmFailed: 'La confirmación falló. Por favor intentá de nuevo.',
    emptySetHint: 'Agregá al menos un competidor para confirmar.',
  },
  gate: {
    enrichmentFailed: 'La medición falló. Revisá los competidores y confirmá de nuevo.',
  },
  report360: {
    title: 'Reporte 360°',
    technicalSeo: 'SEO Técnico',
    downloadPdf: 'Descargar PDF',
    downloadFailed: 'La descarga del PDF falló. Por favor, intenta de nuevo.',
    regeneratePdf: 'Regenerar PDF',
    regenerateFailed: 'La regeneración del PDF falló. Por favor, intenta de nuevo.',
    crawl: 'Crawl',
    on: 'Activado',
    off: 'Desactivado',
    documentFrameTitle: 'Documento de diagnóstico SEO',
    documentLoading: 'Cargando el documento de diagnóstico',
    documentViewTechnical: 'Abrir el análisis técnico',
    documentRetry: 'Reintentar',
    documentErrorTitle: 'No pudimos cargar el documento',
    documentErrorDescription: 'Algo falló al traer el diagnóstico. Probá de nuevo o pasá al análisis técnico.',
    documentUnavailableTitle: 'Este audit no tiene documento de diagnóstico',
    documentUnavailableDescription: 'Terminó antes de que el documento existiera, o no se pudo escribir su texto. Se puede escribir ahora con lo que el audit ya midió, sin volver a crawlear el sitio.',
    downloadHtml: 'Descargar HTML',
    documentWarningTitle: 'Leelo antes de enviarlo',
    documentWarningBody: 'El texto rompió una regla de estilo que los chequeos no pudieron resolver. Lo más común es una tendencia que la auditoría no midió. Revisá la redacción antes de reenviarlo.',
    documentRegenerate: 'Escribir el diagnóstico',
    documentRegenerating: 'Escribiéndolo…',
    documentRegenerateFailed: 'No se pudo escribir el diagnóstico. Probá de nuevo en un momento.',
  },
  export: {
    json: 'JSON',
    csv: 'CSV',
    urlsCsv: 'URLs (CSV)',
    pdf: 'PDF',
    pdfSummary: 'PDF Resumen',
    sectionPdf: 'Descargar PDF',
    sectionPdfDownloading: 'Descargando...',
  },
} as const
